module.exports = __webpack_public_path__ + "static/assets/122b7715b9fa99e84e6af8273925ec3c.jpg";